import { Component, Inject, LOCALE_ID, Renderer2, OnInit, AfterViewChecked } from "@angular/core";
import { ConfigName, ConfigService } from "../@evo/services/config.service";
import { MatIconRegistry } from "@angular/material/icon";
import { Settings } from "luxon";
import { DOCUMENT } from "@angular/common";
import { Platform } from "@angular/cdk/platform";
import { NavigationService } from "../@evo/services/navigation.service";
import icAssigment from "@iconify/icons-ic/twotone-assignment";
import { LayoutService } from "../@evo/services/layout.service";
import { ActivatedRoute, Router, NavigationStart, RoutesRecognized } from "@angular/router";
import { filter, pairwise } from "rxjs/operators";
import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { SplashScreenService } from "../@evo/services/splash-screen.service";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "./pages/Services/shared.service";
import { NavigationItem } from "src/@evo/interfaces/navigation-item.interface";
import { iconsIC } from "src/static-data/icons-ic";
import { EvoGlobalService } from './globals/evo-global.service';
import { StorageService } from './pages/Services/storage.service';
import { environment } from 'src/environments/environment';
import { GlobalCurrentUserService } from './pages/Services/global-current-user.service';
import { CookieService } from "ngx-cookie-service";
import { secureStorage, getSecureItem, setSecureItem } from './pages/Services/secure-storage';

import { Observable, Subscription } from 'rxjs';
import { NetworkService } from './configuration/network.service';
import { LanguageService } from "./pages/Services/language.service";
export let browserRefresh = false;
export let previousUrl;
export let currentUrl;

type IconKeys = keyof typeof iconsIC;
@Component({
  selector: "nc-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, AfterViewChecked {

  title = "MALAK";
  staticMenu: any;
  currentUser: any;
  KEY_VAR: any;
  IV_VAR: any;
  checkLoggedIn = false;
  currentRoute: any;
  currentActivatedRoute: any;

  lang$: Observable<string>;
  subscription: Subscription;

  constructor(
    // public translate: TranslateService,
    private configService: ConfigService,
    private iconRegistry: MatIconRegistry,
    private renderer: Renderer2,
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private splashScreenService: SplashScreenService,
    private sharedService: SharedService,
    private evoGlobalService: EvoGlobalService,
    private storageService: StorageService,
    private globalCurrentUserService: GlobalCurrentUserService,
    private router: Router,
    private cookieService: CookieService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private networkService: NetworkService
  ) {
    this.getConfigs();
    //console.log(this.router.url);
    // this.translate.setDefaultLang("28_1_BOPortal_English"); 
    //console.log("App component");



    // this.evoGlobalService.getConfigurations(environment.KEYS_FILE_NAME).subscribe(result =>{
    //   this.KEY_VAR = result["EVO_KEY"];
    //   this.IV_VAR =result["EVO_IV"];
    //   this.sharedService.updateKeys(result);
    // })
    // this.evoGlobalService.getConfigurations(environment.CONFIG_FILE_NAME).subscribe(result =>{
    //   let key = CryptoJS.enc.Utf8.parse(this.KEY_VAR);
    //             let iv = CryptoJS.enc.Utf8.parse(this.IV_VAR);
    //             let decrypted = CryptoJS.AES.decrypt(result["EvoPortal"]["apiBasicPassword"], key, {
    //                 keySize: 128 / 16,
    //                 iv: iv,
    //                 mode: CryptoJS.mode.CBC,
    //                 padding: CryptoJS.pad.Pkcs7
    //             });


    //   let basicAuthPassword =decrypted.toString(CryptoJS.enc.Utf8);//this.sharedService.decrypt(result["EvoPortal"]["apiBasicPassword"])
    //console.log(basicAuthPassword);
    //console.log("App NgONInit param set");

    // let confiObj={
    //   basicAuthPassword:basicAuthPassword, 
    //   username:result["EvoPortal"]["apiBasicUsername"],
    //   MODULE_ID:result["EvoPortal"]["moduleId"],
    //   MODULE_NAME:result["EvoPortal"]["moduleName"],
    //   RESET_PASS_CALLBACK_LINK:  result["EvoPortal"]["callBackLink"],
    //   basicApiHost:result["EvoPortal"]["apiBasicUrl"],
    //   apiHost:result["EvoPortal"]["apiUrl"],
    //   loginUrl: result["EvoPortal"]["loginUrl"],
    // }
    // this.sharedService.updateConfig(confiObj);
    //language code
    // this.translate.setDefaultLang("28_1_BOPortal_English"); 
    // if (getSecureItem("selectedLang")) {
    //   console.log(getSecureItem("selectedLang"), "selected Lang")
    //   this.languageService.selectedLang = JSON.parse(
    //     getSecureItem("selectedLang")
    //   );
    // } else {
    //   this.languageService.selectedLang = {
    //       "langId": 1,
    //       "shDescNbr": null,
    //       "lgDescNbr": 29946,
    //       "used": true,
    //       "validated": true,
    //       "description": "English",
    //       "fileName" : ""
    //   };
    //   setSecureItem(
    //     "selectedLang",
    //     JSON.stringify(this.languageService.selectedLang)
    //   );
    // }
    // this.languageService.setLanguage(
    //   this.languageService.selectedLang
    // );
    // this.lang$ = this.languageService.getLanguage(); // create name of file
    // this.lang$.subscribe((lang) => {
    //   this.translate.use(lang['fileName']);
    //   localStorage.setItem("lang", lang['langId']);
    //   setSecureItem(
    //     "selectedLang",
    //     JSON.stringify(lang)
    //   );
    // }); //language code
    // this.languageService.getLanguages().then((res) => {
    //   let obj = {
    //     "langId": 10,
    //     "shDescNbr": null,
    //     "lgDescNbr": 29946,
    //     "used": true,
    //     "validated": true,
    //     "description": "Italian",
    //     "fileName" : ""
    //   };
    //   this.languageService.languages = res;
    //   this.languageService.languages.push(obj);
    // },
    // );
    // })
    this.iconRegistry.setDefaultFontSetClass("iconify");
    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, "is-blink");
    }

    this.route.queryParamMap
      .pipe(
        filter(
          queryParamMap =>
            queryParamMap.has("rtl") &&
            coerceBooleanProperty(queryParamMap.get("rtl"))
        )
      )
      .subscribe(queryParamMap => {
        this.document.body.dir = "rtl";
        this.configService.update({
          rtl: true
        });
      });

    this.route.queryParamMap
      .pipe(filter(queryParamMap => queryParamMap.has("style")))
      .subscribe(queryParamMap => {
        this.configService.setConfig(queryParamMap.get("style") as ConfigName);
      });
    this.processMenus();


    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
    });

    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        previousUrl = events[0].urlAfterRedirects;
        currentUrl = events[1].urlAfterRedirects;
      });

  }

  mainMenu: NavigationItem[] = [];
  ngOnInit() {
    //this.sharedService.getCurrentRoute().subscribe(result=> this.currentActivatedRoute = result);
    this.currentUser = this.globalCurrentUserService.getCurrentUser();
    this.globalCurrentUserService.checkLoggedIn.subscribe(
      (response) => {
        this.checkLoggedIn = response;
      }
    )

    //alert(this.currentActivatedRoute==='/change-password' || !this.checkLoggedIn);
  }

  ngAfterViewChecked() {
    if (document.getElementsByTagName) {
      const inputElements = document.getElementsByTagName("input");
      for (let i = 0; inputElements[i]; i++) {
        if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") === -1)) {
          inputElements[i].setAttribute("autocomplete", "off");
          inputElements[i].className = inputElements[i].className + ' disableAutoComplete';
        }
      }
    }
  }
  layoutId: any;
  createRouting(menu) {
    // if (menu.menuItems.length != 0) {
    // }
  }
  prepareMenuItemList(menuItem: any) {
    menuItem &&
      menuItem.forEach(layoutLevel => {
        // console.log(layoutLevel)
        // if(layoutLevel.menuIcon == ""){
        //   layoutLevel.menuIcon = "layers"
        // }
        if (layoutLevel.menuItems.length != 0) {
          layoutLevel.label = layoutLevel.menuName;
          layoutLevel.icon = icAssigment; //iconsIC["icAssigment"]//layoutLevel.menuIcon;
          layoutLevel.children = layoutLevel.menuItems;
          this.prepareMenuItemList(layoutLevel.menuItems);
        } else {
          layoutLevel.label = layoutLevel.menuName;
          layoutLevel.icon = icAssigment;
          layoutLevel.route = "/" + layoutLevel.screenaddress;
          //console.log(layoutLevel);
        }
      });
    this.mainMenu = menuItem;

  }
  copyMenuItem: NavigationItem[] = [];
  createSideNavBarItems(menuItem: NavigationItem[]) {
    const blank = [];
    this.copyMenuItem = [...blank];
    menuItem && menuItem.forEach(firstLevel => {
      if (firstLevel["menuItems"].length === 0) {
        this.copyMenuItem.push(firstLevel);
      } else {
        const levelOne = { label: firstLevel.label };
        this.copyMenuItem.push(levelOne);
        firstLevel["menuItems"].forEach(levelTwo => {
          if (levelTwo["menuItems"].length === 0) {
            this.copyMenuItem.push(levelTwo);
          } else {
            const createLevelTow = { label: levelTwo.label, icon: icAssigment, children: levelTwo["menuItems"] };
            this.copyMenuItem.push(createLevelTow);
          }
        });
      }
    });
    // console.log("copyMenuItem", this.copyMenuItem);
  }

  // async loadMenu(){
  //   console.log("app compo1 loadMenu()")
  //   let menus = await this.evoGlobalService.getRoutes();
  //   console.log("app compo2 loadMenu()")
  //   console.log(menus);
  //    this.sharedService.addMenuItems(menus["menu"]);
  //     //breadcrumbs code
  //                localStorage.setItem("navMenuData", JSON.stringify(menus["menu"]));
  //                this.navigationService.menuItems = [...menus["menu"]];
  //                this.navigationService.crumbs = ["Dashboard"];
  //                this.navigationService.currentRoute = { menuName: "Dashboard" };
  //                localStorage.setItem("currentRoute", JSON.stringify({ menuName: "Dashboard" }));
  //                this.processMenus();

  //  }

  processMenus() {
    //"processMenus")
    this.sharedService.getMenuItems().subscribe(menuItemList => {

      //console.log(menuItemList);
      const items: NavigationItem[] = menuItemList;

      //breadcrumbs code
      this.navigationService.menuItems = [...menuItemList];
      //breadcrumbs code
      if (menuItemList.length != 0) {
        this.prepareMenuItemList(items);
      }


      if (this.mainMenu.length != 0) {
        const temRoute: NavigationItem[] = [];
        this.createSideNavBarItems(this.mainMenu);
        //this.copyMenuItem = this.copyMenuItem.concat(this.staticMenu); //this.staticMenu.concat(this.mainMenu)

        if (this.copyMenuItem.length != 0) {
          this.sharedService.updatePeaparedMenuItem(this.copyMenuItem);
        }

        //ocalStorage.setItem("mainMenu", JSON.stringify(this.copyMenuItem)); 
        //this.navigationService.items = this.mainMenu;
        this.navigationService.items = this.copyMenuItem;
      }
    });
  }

  allTabsLogout() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        // let token = localStorage.getItem('currentUser');
        // let token = JSON.parse(this.cookieService.get('currentUser'));
        const encr = secureStorage.hash("currentUser");
        const tokenExists = this.cookieService.check(encr);
        if (!tokenExists) {
          // Perform logout
          //Navigate to login/home
          this.router.navigate(['/login']);
        }
      }
    });
  }

  async getConfigs() {
    await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);
    this.sharedService.getConfig().subscribe(result => {
      if (!result["MODULE_ID"] ||
        !result["RESET_PASS_CALLBACK_LINK"] ||
        !result["basicApiHost"] ||
        !result["apiHost"] ||
        !result["loginUrl"] ||
        !result["dateFormat"] ||
        !result["MODULE_NAME"]) {
        this.getConfigs();
      } else {
        if (getSecureItem("selectedLang") && this.IsJsonString(getSecureItem("selectedLang")) &&
          JSON.parse(getSecureItem("selectedLang")).langId &&
          JSON.parse(getSecureItem("selectedLang")).description) {
          this.languageService.selectedLang = JSON.parse(getSecureItem("selectedLang"));
        } else {
          this.languageService.selectedLang = {
            "langId": 1,
            "shDescNbr": null,
            "lgDescNbr": 29946,
            "used": true,
            "validated": true,
            "description": "English",
            "fileName": "",
            "languagecode": "en"
          };
          setSecureItem(
            "selectedLang",
            JSON.stringify(this.languageService.selectedLang)
          );
        }
        this.languageService.setLanguage(
          this.languageService.selectedLang
        );
        this.lang$ = this.languageService.getLanguage(); // create name of file
        this.lang$.subscribe((lang) => {
          this.translate.use(lang['fileName']);
          localStorage.setItem("lang", lang['langId']);
          setSecureItem(
            "selectedLang",
            JSON.stringify(lang)
          );
        }); //language code
        this.languageService.getLanguages().then((res) => {
          this.languageService.languages = res;
        },
        );
      }
    });
  }

  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
// {
//   label: "Models Management",
//   icon: icContactSupport,
//   children: [